<template>
    <div class="home" :class="preCls + 'content-box'">
        <!--        <div><button @click="fetch">refresh</button></div>-->
        <Row class="home-row" :gutter="rowGutter">
            <!-- 账单统计 -->
            <!-- prettier-ignore -->
            <Col :xs="12" :lg="{ span: 'bill' }" v-for="(item, index) in billList" :key="index">
                <div class="home-card home-bill flex" @click="onBillClick(item)">
                    <div class="flex column grow">
                        <div class="home-bill-title">{{ item.text }}</div>
                        <div class="home-bill-total" :style="{ color: item.color }">
                            {{ item.total }}
                        </div>
                        <div class="home-bill-today">
                            今日<span :style="{ color: item.color }"> {{item.today }} </span>笔
                        </div>
                    </div>
                    <div class="home-bill-img" :style="{ backgroundColor: item.color }">
                        <common-icon 
                            :type="'_'+item.icon" 
                            :size="32"></common-icon>
                    </div>
                </div>
            </Col>
        </Row>
        <Row class="home-row" :gutter="rowGutter">
            <!-- 异常提醒 -->
            <Col :xs="24" :lg="{ span: 'left' }">
                <div class="home-card">
                    <div class="home-card-title">异常提醒</div>
                    <div class="home-card-body">
                        <Row :gutter="20">
                            <Col
                                v-for="(item, i) in alertList"
                                :key="i"
                                class="home-alert-col"
                                span="6"
                            >
                                <div
                                    class="home-card-col flex column"
                                    :class="{
                                        'is-last': i === alertList.length - 1,
                                    }"
                                >
                                    <div class="home-card-col-total">
                                        {{ item.total }}
                                    </div>
                                    <!-- 水电异常 -->
                                    <template
                                        v-if="
                                            item.key ===
                                                enums.STA_DEVICE_ALERT_TYPE
                                                    .ex_1 ||
                                            item.key ===
                                                enums.STA_DEVICE_ALERT_TYPE.ex_2
                                        "
                                    >
                                        <div class="home-card-col-title">
                                            水电异常
                                        </div>
                                        <div class="home-card-col-title">
                                            （{{ item.text }}）
                                        </div>
                                        <div class="home-card-col-today">
                                            今日
                                            <span>{{ item.today }}</span> 个
                                        </div>
                                    </template>
                                    <!-- 设备离线 -->
                                    <!-- prettier-ignore -->
                                    <template v-else-if="item.key === enums.STA_DEVICE_ALERT_TYPE.onlineErr">
                                        <div class="home-card-col-title">
                                            {{ item.text }}
                                        </div>
                                        <div class="home-card-col-today">
                                            <Button :disabled="item.total <= 0" @click="onOnlineErrClick">查看</Button>
                                        </div>
                                    </template>
                                    <!-- 自动断电 -->
                                    <template v-else>
                                        <div class="home-card-col-title">
                                            {{ item.text }}
                                        </div>
                                        <div class="home-card-col-today">
                                            今日
                                            <span>{{ item.today }}</span> 个
                                        </div>
                                    </template>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Col>
            <!-- 今日账务 -->
            <Col :xs="24" :lg="{ span: 'right' }">
                <div class="home-card">
                    <div class="home-card-title">今日账务</div>
                    <div class="home-card-body">
                        <Row :gutter="60">
                            <Col
                                v-for="(list, i) in accountList"
                                :key="i"
                                class="home-account-col"
                                span="8"
                            >
                                <div
                                    class="home-card-col flex column"
                                    :class="{
                                        'is-last': i === accountList.length - 1,
                                    }"
                                >
                                    <div
                                        v-for="(item, j) in list"
                                        :key="j"
                                        class="home-card-row flex"
                                    >
                                        <div class="home-card-row-title">
                                            {{ item.text }}
                                        </div>
                                        <div class="home-card-row-today">
                                            {{ item.value | yuan | currency }}元
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Col>
        </Row>
        <Row class="home-row" :gutter="rowGutter">
            <!-- 维修投诉 -->
            <Col :xs="24" :lg="{ span: 'left' }">
                <div class="home-card">
                    <div class="home-card-title">维修投诉</div>
                    <div class="home-card-body">
                        <Row :gutter="20">
                            <Col
                                v-for="(item, i) in orderList"
                                :key="i"
                                class="home-order-col"
                                span="6"
                                @click.native="onOrderClick(item)"
                            >
                                <div
                                    class="home-card-col flex column"
                                    :class="{
                                        'is-last': i === orderList.length - 1,
                                    }"
                                >
                                    <div class="home-card-col-total">
                                        {{ item.total }}
                                    </div>
                                    <div class="home-card-col-title">
                                        {{ item.text }}
                                    </div>
                                    <div class="home-card-col-today">
                                        今日 <span>{{ item.today }}</span> 个
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Col>
            <!-- 房源库存 -->
            <Col :xs="24" :lg="{ span: 'right' }">
                <div class="home-card">
                    <div class="home-card-title">房源库存</div>
                    <div class="home-card-body">
                        <Row :gutter="60">
                            <Col class="home-house-col" span="8">
                                <div class="home-card-col flex column">
                                    <div
                                        v-for="(item, j) in houseList"
                                        :key="j"
                                        class="home-card-row home-house-row flex"
                                    >
                                        <div class="home-card-row-title">
                                            {{ item.text }}
                                        </div>
                                        <div class="home-card-row-today">
                                            {{ item.total | currency(0) }}间
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col class="home-house-col" span="8">
                                <home-empty-rate
                                    :value="vacantRate"
                                ></home-empty-rate>
                            </Col>
                            <Col class="home-house-col" span="8">
                                <!--                                <home-empty-days-->
                                <!--                                    :value="vacantArr"-->
                                <!--                                ></home-empty-days>-->
                            </Col>
                        </Row>
                    </div>
                </div>
            </Col>
        </Row>
        <Row class="home-row" :gutter="rowGutter">
            <!-- 出房退房 -->
            <Col :xs="24" :lg="{ span: 'left' }">
                <div class="home-card">
                    <div class="home-card-title">出房退房</div>
                    <div class="home-card-body">
                        <Row :gutter="80">
                            <Col
                                v-for="(list, i) in rentList"
                                :key="i"
                                class="home-rent-col"
                                span="12"
                            >
                                <div
                                    class="home-card-col flex column"
                                    :class="{
                                        'is-last': i === rentList.length - 1,
                                    }"
                                >
                                    <div
                                        v-for="(item, j) in list"
                                        :key="j"
                                        class="home-card-row flex"
                                    >
                                        <div class="home-card-row-title">
                                            {{ item.text }}
                                        </div>
                                        <div class="home-card-row-today">
                                            {{ item.total | currency(0) }}间
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Col>
            <!-- 合约到期 -->
            <Col :xs="24" :lg="{ span: 'right' }">
                <div class="home-card">
                    <div class="home-card-title">合约到期</div>
                    <div class="home-card-body">
                        <div class="home-expire-col">
                            <home-contract-expire
                                :value="contractExpire.data"
                                :times="contractExpire.times"
                            ></home-contract-expire>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
        <!-- 设备离线 Modal -->
        <smart-modal
            v-model="showOnlineErr"
            :title="'设备离线'"
            :height="720"
            :width="960"
            :buttons="[{ type: 'default', text: '关闭', name: 'close' }]"
        >
            <!-- 复用table组件样式 -->
            <div class="ivu-table">
                <table style="width: 100%" cellspacing="0">
                    <colgroup>
                        <col width="80" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="ivu-table-column-center">
                                <div class="ivu-table-cell">序号</div>
                            </th>
                            <th><div class="ivu-table-cell">房间</div></th>
                            <th><div class="ivu-table-cell">设备类型</div></th>
                            <th><div class="ivu-table-cell">表号</div></th>
                            <th>
                                <div class="ivu-table-cell">问题严重程度</div>
                            </th>
                            <th
                                v-if="alerts.onlineErr.list.length > 11"
                                :width="scrollBarSize"
                            ></th>
                        </tr>
                    </thead>
                </table>
                <div style="height: 550px; overflow: auto">
                    <table style="width: 100%" cellspacing="0">
                        <colgroup>
                            <col width="80" />
                        </colgroup>
                        <tbody>
                            <tr
                                v-for="(row, i) in alerts.onlineErr.list"
                                :key="i"
                            >
                                <td
                                    class="ivu-table-cell ivu-table-column-center"
                                >
                                    {{ i + 1 }}
                                </td>
                                <td class="ivu-table-cell">
                                    {{ row.houseName }}
                                </td>
                                <td class="ivu-table-cell">
                                    {{ row.meterType }}
                                </td>
                                <td class="ivu-table-cell">
                                    {{ row.deviceNo }}
                                </td>
                                <td
                                    class="ivu-table-cell"
                                    :style="{ color: row.numText.color }"
                                >
                                    {{ row.numText.text }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </smart-modal>
    </div>
</template>
<script>
import {
    iotException,
    liveRateStatistic,
    houseContractStatistic,
    inAndOutStatistic,
    billAccountStatistic,
    repairComplaintStatistic,
    billContractStatistic,
} from '@/api/ems-stats'
import { groupBy } from '_u/helper'
import HomeEmptyRate from '_vc/chart/home-empty-rate'
import HomeEmptyDays from '_vc/chart/home-empty-days'
import HomeContractExpire from '_vc/chart/home-contract-expire'
import { getScrollBarSize } from 'ivux/src/utils/assist'

export default {
    name: 'IndexHome',
    components: {
        HomeEmptyRate,
        HomeEmptyDays,
        HomeContractExpire,
    },
    data() {
        return {
            // state
            loading: false,
            showOnlineErr: false,
            rowGutter: 18,
            scrollBarSize: getScrollBarSize(),
            // data
            bills: {
                unConfirm: { total: 0, today: 0 },
                unCollect: { total: 0, today: 0 },
                unPay: { total: 0, today: 0 },
                expiring: { total: 0, today: 0 },
                midRefund: { total: 0, today: 0 },
            },
            alerts: {
                ex_1: { total: 0, today: 0 },
                ex_2: { total: 0, today: 0 },
                onlineErr: { total: 0, today: 0, list: [] },
                ex_4: { total: 0, today: 0 },
            },
            accounts: {
                toReceivedToday: { value: 0 },
                receivedToday: { value: 0 },
                debtTotal: { value: 0 },
                toPayToday: { value: 0 },
                payToday: { value: 0 },
                oweToPayTotal: { value: 0 },
                toConfirmToday: { value: 0 },
                confirmToday: { value: 0 },
                unConfirmTotal: { value: 0 },
            },
            orders: {
                unComplete: { total: 0, today: 0 },
                unPaid: { total: 0, today: 0 },
                paid: { total: 0, today: 0 },
                complaint: { total: 0, today: 0 },
            },
            houses: {
                rentCount: { total: 0 },
                scheduledCount: { total: 0 },
                lockedCount: { total: 0 },
                vacantCount: { total: 0 },
            },
            vacantRate: 0,
            vacantArr: [0, 0, 0, 0],
            rents: {
                inByToday: { total: 0 },
                inByWeek: { total: 0 },
                inByMonth3: { total: 0 },
                outByToday: { total: 0 },
                outByWeek: { total: 0 },
                outByMonth: { total: 0 },
            },
            contractExpire: {
                data: [],
                times: [],
            },
            enums: {
                STA_BILL_STATUS: this.$enum.get('STA_BILL_STATUS'),
                STA_DEVICE_ALERT_TYPE: this.$enum.get('STA_DEVICE_ALERT_TYPE'),
                STA_FINANCE_ACCOUNT_TYPE: this.$enum.get(
                    'STA_FINANCE_ACCOUNT_TYPE'
                ),
                STA_REPAIR_CPMPLAINT_TYPE: this.$enum.get(
                    'STA_REPAIR_CPMPLAINT_TYPE'
                ),
                STA_RENT_TYPE: this.$enum.get('STA_RENT_TYPE'),
                STA_HOUSE_STATUS: this.$enum.get('STA_HOUSE_STATUS'),
            },
        }
    },
    computed: {
        // 账单数据
        billList() {
            var STA_BILL_STATUS = this.enums.STA_BILL_STATUS

            return Object.keys(this.bills).map((k) => {
                var v = this.bills[k],
                    meta = STA_BILL_STATUS.getMeta(k)

                return {
                    key: k,
                    text: STA_BILL_STATUS.getName(k),
                    ...meta,
                    ...v,
                }
            })
        },
        // 异常数据
        alertList() {
            var STA_DEVICE_ALERT_TYPE = this.enums.STA_DEVICE_ALERT_TYPE

            return Object.keys(this.alerts).map((k) => {
                var v = this.alerts[k],
                    meta = STA_DEVICE_ALERT_TYPE.getMeta(k),
                    text = STA_DEVICE_ALERT_TYPE.getName(k)

                return {
                    key: k,
                    text,
                    ...meta,
                    ...v,
                }
            })
        },
        // 账务数据
        accountList() {
            var STA_FINANCE_ACCOUNT_TYPE = this.enums.STA_FINANCE_ACCOUNT_TYPE
            var list = Object.keys(this.accounts).map((k) => {
                var v = this.accounts[k],
                    meta = STA_FINANCE_ACCOUNT_TYPE.getMeta(k),
                    text = STA_FINANCE_ACCOUNT_TYPE.getName(k)

                return {
                    key: k,
                    text,
                    ...meta,
                    ...v,
                }
            })

            return groupBy(list, (v, i) => parseInt(i / 3))
        },
        // 维修投诉数据
        orderList() {
            var STA_REPAIR_CPMPLAINT_TYPE = this.enums.STA_REPAIR_CPMPLAINT_TYPE

            return Object.keys(this.orders).map((k) => {
                var v = this.orders[k],
                    meta = STA_REPAIR_CPMPLAINT_TYPE.getMeta(k),
                    text = STA_REPAIR_CPMPLAINT_TYPE.getName(k)

                return {
                    key: k,
                    text,
                    ...meta,
                    ...v,
                }
            })
        },
        // 出房退房数据
        rentList() {
            var STA_RENT_TYPE = this.enums.STA_RENT_TYPE
            var list = Object.keys(this.rents).map((k) => {
                var v = this.rents[k],
                    meta = STA_RENT_TYPE.getMeta(k),
                    text = STA_RENT_TYPE.getName(k)

                return {
                    key: k,
                    text,
                    ...meta,
                    ...v,
                }
            })

            return groupBy(list, (v, i) => parseInt(i / 3))
        },
        // 房源库存数据
        houseList() {
            var STA_HOUSE_STATUS = this.enums.STA_HOUSE_STATUS
            var list = Object.keys(this.houses).map((k) => {
                var v = this.houses[k],
                    meta = STA_HOUSE_STATUS.getMeta(k),
                    text = STA_HOUSE_STATUS.getName(k)

                // 全部
                if (k === 'total') {
                    return {
                        key: 'all',
                        text: '全部',
                        total: v.total,
                    }
                } else {
                    return {
                        key: k,
                        text,
                        ...meta,
                        ...v,
                    }
                }
            })

            return list
        },
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            // 账单
            billContractStatistic().then((res) => {
                this.setBillContractData(res.data)
            })
            // 异常提醒
            iotException().then((res) => {
                this.setIotException(res.data)
            })
            // 账务
            billAccountStatistic().then((res) => {
                this.setBillAccountData(res.data)
            })
            // 维修
            repairComplaintStatistic().then((res) => {
                this.setRepairComplaintData(res.data)
            })
            // 房源
            liveRateStatistic().then((res) => {
                this.setLiveRate(res.data)
            })
            // 出房退房
            inAndOutStatistic().then((res) => {
                this.setInAndOutData(res.data)
            })
            // 合约到期
            houseContractStatistic().then((res) => {
                this.setHouseContractData(res.data)
            })
        },
        // 点击账单
        onBillClick(item) {
            var STA_BILL_STATUS = this.enums.STA_BILL_STATUS
            switch (item.key) {
                case STA_BILL_STATUS.unConfirm:
                case STA_BILL_STATUS.unCollect:
                    this.$router.push({
                        name: 'billInfo',
                        query: {
                            active: 'billDs', // 账单-待收账单
                        },
                    })
                    break
                case STA_BILL_STATUS.unPay:
                    this.$router.push({
                        name: 'billInfo',
                        query: {
                            active: 'billDf', // 账单-待付账单
                        },
                    })
                    break
                case STA_BILL_STATUS.expiring:
                    this.$router.push({
                        name: 'contractIndex',
                        query: {
                            active: 'contractRent', // 合同-在租合同
                        },
                    })
                    break
                case STA_BILL_STATUS.midRefund:
                    this.$router.push({
                        name: 'contractIndex',
                        query: {
                            active: 'contractHistory', // 合同-历史合同
                        },
                    })
                    break
            }
        },
        // 点击维修投诉
        onOrderClick(item) {
            var STA_REPAIR_CPMPLAINT_TYPE = this.enums.STA_REPAIR_CPMPLAINT_TYPE
            switch (item.key) {
                case STA_REPAIR_CPMPLAINT_TYPE.unComplete:
                case STA_REPAIR_CPMPLAINT_TYPE.unPaid:
                case STA_REPAIR_CPMPLAINT_TYPE.paid:
                    this.$router.push({
                        name: 'dailyIndex',
                        query: {
                            active: 'dailyRepairList', // 维修投诉-维修工单
                        },
                    })
                    break
                case STA_REPAIR_CPMPLAINT_TYPE.complaint:
                    this.$router.push({
                        name: 'dailyIndex',
                        query: {
                            active: 'dailyComplaintList', // 维修投诉-投诉
                        },
                    })
                    break
            }
        },
        // 查看离线设备
        onOnlineErrClick() {
            this.showOnlineErr = true
        },
        setIotException({
            onlineErr = [], // 离线错误列表
        }) {
            // 问题程度
            onlineErr.forEach((v) => {
                switch (true) {
                    case v.num > 15:
                        v.numText = {
                            text: '轻微',
                            color: '#F69A35',
                        }
                        break
                    case v.num >= 5 && v.num <= 15:
                        v.numText = {
                            text: '中度',
                            color: '#D740BC',
                        }
                        break
                    case v.num < 5:
                        v.numText = {
                            text: '严重',
                            color: '#E04B58',
                        }
                        break
                }
            })
            this.alerts.onlineErr.total = onlineErr.length
            this.alerts.onlineErr.list = onlineErr
        },
        setBillContractData({
            unConfirmToday, //今日待确认账单数量
            unConfirmTotal, //累计待确认账单数量1(1：完成、0：未完成)
            unCollectToday, //今日未收账单
            unCollectTotal, //累计未收账单
            unPayToday, //今日待付账单
            unPayTotal, //累计待付账单
            expiring, //即将到期合同数量
            expireToday, //今日即将到期合同
            midRefundToday, //今日违约退租的数量
            midRefundTotal, //累计违约退租的数量
        }) {
            // prettier-ignore
            this.bills = {
                unConfirm: { total: unConfirmTotal, today: unConfirmToday },
                unCollect: { total: unCollectTotal, today: unCollectToday },
                unPay: { total: unPayTotal, today: unPayToday },
                expiring: { total: expiring, today: expireToday },
                midRefund: { total: midRefundTotal, today: midRefundToday },
            }
        },
        setBillAccountData({
            toReceivedToday, //今日应收
            receivedToday, //今日实收
            debtTotal, //累计应收
            toPayToday, //今日应付
            payToday, //今日实付
            oweToPayTotal, //累计欠付
            toConfirmToday, //今日待确认
            confirmToday, //今日已确认
            unConfirmTotal, //累计未确认
        }) {
            // prettier-ignore
            this.accounts = {
                toReceivedToday: { value: toReceivedToday },
                receivedToday: { value: receivedToday },
                debtTotal: { value: debtTotal },
                toPayToday: { value: toPayToday },
                payToday: { value: payToday },
                oweToPayTotal: { value: oweToPayTotal },
                toConfirmToday: { value: toConfirmToday },
                confirmToday: { value: confirmToday },
                unConfirmTotal: { value: unConfirmTotal },
            }
        },
        setRepairComplaintData({
            unCompleteTotal, //累计待完成维修数量
            unCompleteToday, //今日待完成维修数量
            unPaidTotal, //累计待交费维修数量
            unPaidToday, //今日待交费维修数量
            paidTotal, //累计已交费维修数量
            paidToday, //今日已交费维修数量
            complaintTotal, //累计投诉待处理数量
            complaintToday, //今日投诉待处理数量
        }) {
            // prettier-ignore
            this.orders = {
                unComplete: { total: unCompleteTotal, today: unCompleteToday },
                unPaid: { total: unPaidTotal, today: unPaidToday },
                paid: { total: paidTotal, today: paidToday },
                complaint: { total: complaintTotal, today: complaintToday },
            }
        },
        setLiveRate({
            total, //全部数量
            rentCount, //租住中数量
            scheduledCount, //预定中数量
            lockedCount, //锁定中数量
            vacantCount, //退租/空置数量
            lev1, //
            lev2, //
            lev3, //
            lev4, //
        }) {
            // prettier-ignore
            this.houses = {
                total: { total: total },
                rentCount: { total: rentCount },
                scheduledCount: { total: scheduledCount },
                lockedCount: { total: lockedCount },
                vacantCount: { total: vacantCount },
            }
            this.vacantRate = total === 0 ? 0 : vacantCount / total
            this.vacantArr = [lev1, lev2, lev3, lev4]
        },
        setInAndOutData({
            inByToday, //今日出房
            inByWeek, //本周出房
            inByMonth, //本月出房
            outByToday, //今日退房
            outByWeek, //本周退房
            outByMonth, //本月退房
        }) {
            // prettier-ignore
            this.rents = {
                inByToday: { total: inByToday}, //今日出房
                inByWeek: { total: inByWeek}, //本周出房
                inByMonth: { total: inByMonth}, //本月出房
                outByToday: { total: outByToday}, //今日退房
                outByWeek: { total: outByWeek}, //本周退房
                outByMonth: { total: outByMonth}, //本月退房
            }
        },
        setHouseContractData({ dataList = [] }) {
            // prettier-ignore
            Object.assign(this.contractExpire, {
                data: dataList.map(v => v.total),
                times: dataList.map(v => v.m),
            })
            // 时间升序排序
            this.contractExpire.times.sort((a, b) => {
                return Date.parse(a) - Date.parse(b)
            })
        },
    },
}
</script>

<style lang="less" scoped>
// lg 栅格布局
@media (min-width: @screen-lg-min) {
    .@{css-prefix}col-span-lg{
        // 账单
        &-bill{
            width: 20%;
        }
        // 左右
        &-left{
            width: 40%;
        }
        &-right{
            width: 60%;
        }
    }
}

.home {
    background-color: #efefef;
    color: @text-color;

    // 卡片布局
    &-card{
        margin-bottom: 18px;
        border: solid 1px  @border-color-split;
        border-radius: 4px;
        background-color: #ffffff;
        box-shadow: rgba(215, 215, 215, 0.35) 0px 0px 8px;

        background: #ffffff;
        &-title{
            padding: 12px 18px;
            border-bottom: solid 1px @border-color-split;
            line-height: 19px;
            font-size: 14px;
        }
        &-body{
            padding: 20px 18px;
            line-height: 16px;
            font-size: 12px;
        }
        // 纵向排版
        &-col{
            height: 100%;

            &:after{
                content: '';
                display: inline-block;
                width: 1px;
                height: 100%;
                position: absolute;
                top: 50%;
                right: -4px;
                background: @border-color-split;
                transform: translateY(-50%);
            }
            &.is-last{
                &:after{
                    display: none;
                }
            }
            &-title{
                flex: 1 0 0;
                line-height: 18px;
                font-size: 16px;
                font-weight: 500;
            }
            &-total{
                line-height: 38px;
                font-size: 28px;
                font-weight: 500;
            }
            &-today{
                margin-top: 16px;
                line-height: 16px;
                font-size: 12px;

                span{
                    color: red;
                }
            }
        }
        // 横向排版
        &-row{
            margin-bottom: 16px;

            &:last-child{
                margin-bottom: 0;
            }

            &-title{
                font-size: 12px;
            }
            &-today{
                font-size: 12px;
                flex: 1 0 0;
                text-align: right;
            }
        }
    }

    // 账单
    &-bill{
        padding: 20px 18px;
        cursor: pointer;

        &-title{
            margin-bottom: 6px;
            font-size: 16px;
        }
        &-total{
            line-height: 48px;
            font-size: 36px;
            font-weight: 500;
        }
        &-today{
            font-size: 12px;
            font-weight: 400;
            text-align: left;
            color: @text-color;
        }
        &-img{
            width: 56px;
            height: 56px;
            line-height: 56px;
            border-radius: 50%;
            text-align: center;
            color: #fff;

            i {
                margin-left: 1px;
            }
        }
    }

    // 各模块UI
    &-alert, &-account, &-order, &-rent{
        &-col{
            height: 125px;
            margin: 10px 0;
            text-align: center;
        }
    }
    &-house, &-expire{
        &-col{
            height: 145px;
            text-align: center;
        }
    }
    &-house{
        &-row{
            margin-bottom: 10px;
        }
    }
    &-order{
        &-col{
            cursor: pointer;
        }
    }
}
</style>
